/** TODO :: Придумать название для dbs и отрефакторит */

export const recipient_form = {
  number_count: '0 номеров | {count} номер | {count} номера | {count} номеров',
  ['include-dbs']: 'Включенные базы данных',
  ['exclude-dbs']: 'Исключенные базы данных',

  field: {
    number: 'Номер'
  },

  button: {
    add_recipients: 'Добавить получателей',
    add_number: 'Добавить номер'
  },

  tab: {
    include: {
      title: 'Включить базу',
      required_format:
        'Убедитесь, что база рассылки содержит только номера в международном формате.'
    },

    exclude: {
      title: 'Исключить базу'
    },

    recipient: {
      title: 'Добавить номера',
      description:
        'Добавьте не более 100 номеров в это окно. Каждый номер должен быть с новой строки. Номера должны быть в международном формате. Например, +7XXXXXXXXXX.'
    }
  },

  send: {
    description: 'Рассылка будет отправлена на',
    cost: 'Ориентировочная стоимость {cost}',
    send: 'Отправить'
  }
};
